import PropTypes from "prop-types";
import React from "react";
import "./BigForm.css";

const BigForm = props => (
  <div className="bigForm">
    <h1>{props.header}</h1>
    <div className={props.successText.length > 0 ? "hide" : ""}>
      {props.children}
    </div>
    <div className={props.errorText.length ? "alert alert-danger" : "hide"}>
      {props.errorText}
    </div>
    <div className={props.successText.length ? "alert alert-success" : "hide"}>
      {props.successText}
    </div>
  </div>
);

BigForm.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.string.isRequired,
  errorText: PropTypes.string,
  successText: PropTypes.string,
};

BigForm.defaultProps = {
  errorText: "",
  successText: "",
};

export default BigForm;



// WEBPACK FOOTER //
// ./src/components/BigForm/BigForm.js